import { Modal, ModalBody, ModalHeader, ModalFooter } from "react-bootstrap"
import React from "react"
import { SearchSelect } from "./search_select"
import { useCopyCustomerCourseMutation, useGetCustomerCoursesQuery, useGetCustomersQuery } from "../api/courses"
import { useState } from "react"
import { showNotification, showErrorNotification } from "../../shared/helpers"

export const CopyCourseModal = ({show, setShow}) => {

  const [searchQuery, setSearchQuery] = useState()
  const [selectedCustomer, setSelectedCustomer] = useState()
  const [selectedCourse, setSelectedCourse] = useState()
  const {data: options} = useGetCustomersQuery({q: searchQuery}, {skip: !show || !searchQuery})
  const {data: importableCourses} = useGetCustomerCoursesQuery({customer: selectedCustomer}, {skip: !show || !selectedCustomer})
  const [copyCourse] = useCopyCustomerCourseMutation()

  const handleSearchChange = (value) => {
    setSearchQuery(value)
  }

  const handleSelectChange = (value) => {
    setSelectedCustomer(value)
  }

  const handleCourseSelect = (event) => {
    setSelectedCourse(event.target.value)
  }

  const handleSave = async () => {
    try {
      await copyCourse({ course: selectedCourse, customer: selectedCustomer }).unwrap();
      setShow(false);
      showNotification('Course copied successfully')
      window.location.reload()
    } catch (error) {
      showErrorNotification("Failed to copy the course")
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        size='sm'
        className="center-modal">
          <div className="courses-modal-title-container">
            <div className="courses-modal-title">
              COPY COURSE FROM CUSTOMER
            </div>
          </div>
           <ModalBody className="courses-small-modal-body-container">
              <div className="add-margin-top-10">
                <SearchSelect 
                  placeholder='Search for a Customer'
                  handleSearchChange={handleSearchChange}
                  handleSelectChange={handleSelectChange}
                  options={options}/>
              </div>
              {
                importableCourses && importableCourses.length > 0 &&
                <div className="add-margin-top-10 courses_box">
                  <label className="bold">Courses:</label>
                  <select 
                    className="add-margin-left-10" 
                    onChange={handleCourseSelect}
                    value={selectedCourse || ""} // Ensures it defaults to empty if state is null
                  >
                    <option value="" disabled>Select a course...</option>
                    {
                      importableCourses.map((course) => (
                        <option key={course.value} value={course.value}>
                          {course.label}
                        </option>
                      ))
                    }
                  </select>
                </div>
              }
              <div className="btsp_notices add-margin-top-20">
              This is an admin only functionality that allows copying courses across customers. The button is not displayed for non Golf Genius admin users. Please start by typing in a few characters and select the course that you are looking for.
              </div>
            </ModalBody>
            <ModalFooter>
              <div className="courses-modal-buttons-container">
                <button onClick={() => setShow(false)} className="cancel_action small grey button btsp_small_white_button">Cancel</button>
                <button onClick={handleSave} className="next_action small orange button btsp_small_orange_button">Copy In</button>
              </div>
            </ModalFooter>
      </Modal>
    </>
  )
}